import { TRoomDetail } from '@/entities/room'
import { isNilOrEmptyString } from '@/shared/lib'

import { ExpandableText, Heading } from '../common'

export type Props = Pick<TRoomDetail, 'usageGuide'>

export const UsageGuide = ({ usageGuide }: Props) => {
  if (isNilOrEmptyString(usageGuide)) return null

  return (
    <section className="w-full space-y-3">
      <Heading>방 이용 방법</Heading>
      <ExpandableText content={usageGuide} />
    </section>
  )
}
